import {
  IBrilliantDevices,
  IIntegrationsCard,
} from "../../interfaces/interfaces";
import InstallationSettingsCard from "../unitDetails/InstallationSettingsCard";
import {
  BrilliantDevices,
  IntegrationDevices,
} from "../unitDetails/common/CommonUnitDetailsComponents";
import { isDateMoreThanThirtyMinutesOld } from "../../utils/utils";

import ViewMembers from "./ViewMembers";

export interface HomeLargeBodyProps {
  brilliantDevices: IBrilliantDevices;
  shouldShowChangeActivity: boolean;
  propertyId: string;
  integrations: IIntegrationsCard[];
  openEditResidentModal: () => void;
  setShowInviteTenantModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowHomePasscodeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const HomeLargeBody: React.FC<HomeLargeBodyProps> = ({
  brilliantDevices,
  propertyId,
  integrations,
  openEditResidentModal,
  setShowInviteTenantModal,
  setShowHomePasscodeModal,
}) => {
  const IsEveryControlOffline =
    brilliantDevices.installedBrilliantControls.every((control) =>
      isDateMoreThanThirtyMinutesOld(control.lastKnownCloudSync)
    );
  return (
    <div className="brilliant-container">
      <div className="brilliant-container-name center-align-as-row">
        <div className="menu">Members</div>
      </div>
      <ViewMembers
        propertyId={propertyId}
        openEditResidentModal={openEditResidentModal}
        setShowInviteTenantModal={setShowInviteTenantModal}
      />
      <br />
      <div className="brilliant-container-name menu">Brilliant</div>
      <BrilliantDevices
        brilliantControls={brilliantDevices.installedBrilliantControls}
        brilliantSwitches={brilliantDevices.installedBrilliantSwitches}
        brilliantPlugs={brilliantDevices.installedBrilliantPlugs}
        isInReconfigState={false}
        isProView
      />
      <div>
        <div className="brilliant-container-name menu">Integrations</div>
        <IntegrationDevices
          integrationDevices={integrations}
          isInReconfigState={false}
          IsEveryControlOffline={IsEveryControlOffline}
        />
      </div>
      <div>
        <div className="brilliant-container-name menu">Settings</div>
        <div className="brilliant-container-cards">
          <InstallationSettingsCard
            data={{ settingName: "Home Passcode" }}
            openModalFn={() => {
              setShowHomePasscodeModal(true);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HomeLargeBody;
